import { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (item) => {
    setCartItems((prev) => {
      const found = prev.find((i) => i.title === item.title);
      if (found) {
        return prev.map((i) =>
          i.title === item.title ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  };

  const removeFromCart = (title) => {
    setCartItems((prev) => prev.filter((i) => i.title !== title));
  };
const removeAllFromCart = () => {
  setCartItems([]);
};
  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart,removeAllFromCart }}>
      {children}
    </CartContext.Provider>
  );

  
};
